import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import React, { useMemo } from 'react';
import { ThemeConsumer } from '@rneui/themed';

const getColorFromString = (str: string) => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	const h = Math.abs(hash) % 360;
	return `hsl(${h}, 70%, 80%)`;
};


const getTextColorFromString = (str: string) => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	const h = Math.abs(hash) % 360;
	return `hsl(${h}, 80%, 30%)`;
};

interface ProductPlaceholderProps {
	name: string;
	style?: ViewStyle;
}

export default function ProductPlaceholder({ name, style }: ProductPlaceholderProps) {

	const backgroundColor = useMemo(() => getColorFromString(name), [name]);
	const textColor = useMemo(() => getTextColorFromString(name), [name]);

	const initials = useMemo(() => {
		return name
			.split(' ')
			.filter(word => word.length > 0)
			.map((n) => n[0])
			.slice(0, 2)
			.join('')
			.toUpperCase();
	}, [name]);

	const containerHeight = style?.height || 100;
	const fontSize = typeof containerHeight === 'number' ? containerHeight * 0.4 : 40;

	return (
		<ThemeConsumer>
			{({ theme }) => (
				<View style={[styles.container, { backgroundColor: theme?.blue50 }, style]}>
					<Text style={[styles.text, { color: theme?.blue600, fontSize }]}>
						{initials}
					</Text>
					<View style={[styles.decoration, { backgroundColor: theme?.blue200 }]} />
				</View>
			)}
		</ThemeConsumer>
	);
}

const styles = StyleSheet.create({
	container: {
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden',
		width: '100%'
	},
	text: {
		fontWeight: '800',
		opacity: 0.9,
	},
	decoration: {
		position: 'absolute',
		bottom: -20,
		right: -20,
		width: '100%',
		height: '100%',
		aspectRatio: 1,
		borderRadius: 999,
		opacity: 0.1,
	}
});